import { Divider as AntDivider, DividerProps } from "antd";
import styled from "styled-components";

export const Divider: typeof AntDivider = styled(AntDivider)<DividerProps>``;
